import axios from 'axios'
import store from '@/store/index'

const instance = axios.create({
	baseURL: process.env.VUE_APP_API_URL,

	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
		'device-id': 111,
		'Access-Control-Allow-Origin': '*',
		'Access-Control-Allow-Headers': '*',
	},
})
instance.interceptors.response.use(
	(response) => {
		return response
	},
	async (error) => {
		const { response } = error
		if (response && response.status === 403) {
			try {
				await store.dispatch('auth/getProfile')
			} catch (Error) {
				if (Error.response.status === 401) {
					await store.dispatch('auth/logout')
					window.location.href = '/auth/login'
				}
				return Promise.reject(error)
			}
		}
	}
)

export default instance
